
import { Box } from "@material-ui/core";
import { useAsyncAction } from "legacy-components/form/action/AsyncAction";
import DataRemover from "modus/components/misc/DataRemover";
import React from "react";
import { useSelector } from "react-redux";
import TeamService from "../../services/TeamService";


interface MemberDissociatorProps {
    userName: string;
    userId: string;
    teamName: string;
    onDeleteSuccess?: () => void;
    isDisabled?: boolean;
}

export const MemberDissociator: React.FC<MemberDissociatorProps> = ({ userName, userId, teamName , onDeleteSuccess, isDisabled}) => {

    const [state, {subscribe}] = useAsyncAction(() => TeamService.removeUserFromTeam(userId, teamName));
    
    return (
        <DataRemover
            onConfirm={subscribe}
            asyncActionState={state}
            title="Are you Sure?"
            successMessage={`${userName} is removed from this team`}
            onSuccess={onDeleteSuccess}
            tooltipText={isDisabled ? "Cannot delete own member from team" : "Remove"}
            variant="text"
            size="small"
            disabled={isDisabled}
            message={
                <Box>
                    <Box marginTop={"30px"}>
                        Do you want to remove <b>{userName}</b> from this team?
                    </Box>
                </Box>
            }
        />
    )
}